<template>
  <div v-if="value" class="card-purchase-summary">
    <div class="card-purchase-summary__container z-index-1">
      <template v-if="isDisplayPayment">
        <div class="card-purchase-summary__payment">
          <template v-if="!campaign">
            <div class="card-purchase-summary__wrapper">
              <p class="card-purchase-summary__label-parcel" v-if="!recurrent"> {{labelInstallment}} </p>
              <strong class="card-purchase-summary__value-parcel">{{ valueInstallment }}</strong>
            </div>
            <div class="card-purchase-summary__wrapper">
              <p class="card-purchase-summary__label-amount" v-if="!recurrent">{{ label }}</p>
              <strong class="card-purchase-summary__value-amount">{{ value }}</strong>
            </div>
          </template>
          <template v-else-if="campaign?.active">
            <div class="card-purchase-summary__wrapper">
              <p class="card-purchase-summary__label-parcel card-purchase-summary__campaign">
                Primeira parcela
              </p>
              <strong class="card-purchase-summary__value-parcel">{{ campaign.amount | currency }}</strong>
            </div>
            <div class="card-purchase-summary__wrapper">
              <p class="card-purchase-summary__label-parcel"> {{valueInstallment}} </p>
              <strong class="card-purchase-summary__value-parcel">{{ value }}</strong>
            </div>
          </template>
        </div>
      </template>
      <button class="card-purchase-summary__button" @click="openModal">
        <strong class="card-purchase-summary__label-bag">
        <cp-icon class="card-purchase-summary__icon" path="/icons/bag-shopping-2.svg" />
        Ver Sacola
        </strong>
      </button>
    </div>
  </div>
</template>
<script>
import cpIcon from '@/components/atoms/Icon.vue'
import { currency } from '@/utils/filters'

export default {
  name: 'CardPurchaseSummary',
  props: {
    isDisplayPayment: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: 'Total'
    },
    value: {
      type: [String, Number],
      requered: true
    },
    valueInstallment: {
      type: [String, Number],
      requered: true
    },
    labelInstallment: {
      type: String,
      requered: true
    },
    recurrent: {
      type: Boolean,
      default: false
    },
    campaign: {
      type: Object,
      default: null
    }
  },
  components: {
    cpIcon
  },
  filters: {
    currency
  },
  methods: {
    openModal () {
      this.$emit('openModal')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/_variables";

  .card-purchase-summary {
    backdrop-filter: blur(4px);
    bottom: 0;
    padding-bottom: 16px;
    position: sticky;

    &__container {
      background-color: #ffffff;
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      color: #444444;
      margin-left: auto;
      margin-right: auto;
      padding: 16px 20px;
      position: relative;
      width: calc(100% - 32px);
    }

    &__payment {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
    }

    &__wrapper {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      &:last-child{
        align-items: flex-end;
      }
    }

    &__label-parcel {
      font-family: $rubik-font-family;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #373739;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    &__label-amount {
      font-family: $rubik-font-family;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: #000000;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    &__value-parcel {
      font-family: $rubik-font-family;
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #1A71B4;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    &__value-amount {
      font-family: $oscine-font-family;
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 28px;
      text-align: right;
      color: #000000;
      flex: none;
      order: 1;
      flex-grow: 0;
    }

    &__button {
      box-sizing: border-box;
      border: 1px solid #1A71B4;
      border-radius: 28px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 24px;
      gap: 8px;
      width: 100%;
      height: 40px;
    }

    &__label-bag {
      font-family: $rubik-font-family;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #373739;
      flex: none;
      order: 1;
      flex-grow: 0;
      gap: 10px;
    }

    &__icon {
      width: 20px;
      height: 20px;
      flex: none;
      order: 0;
      flex-grow: 0;
    }
  }
</style>
